export const environment = {
  production: false,
  // taxpayer_base_url: 'http://172.27.40.168:5000',
  // archive_portal_url: ' http://103.92.85.227:42005',
  // verification_base_url : 'http://103.92.85.227:42001' ,
  // eLedger_portal_url: 'http://172.27.40.176:42003',
  taxpayer_base_url: 'https://sapi.etaxnbr.gov.bd',
  archive_portal_url: ' http://103.92.85.227:42005',
  verification_base_url : 'http://103.92.85.227:42001' ,
  eLedger_portal_url: 'https://sledger.etaxnbr.gov.bd',
  siteKey: '6LcpdFAsAAAAAJRRxXKIpOKCtbIIrPYioUpUha6Z',
  isCaptchaValidationOpen: false,

  enableSpecialRegistration: true,

  taxPaymentEdit: false,
  sentry_dsn: 'https://947b0e2e6a6445434438b1bd8946e9ef@sentry.etaxnbr.gov.bd/8'

};
